import VueI18n from "vue-i18n";

export default function() {
  return new VueI18n({
    locale: "de",
    messages: {
      en: {
        message: {
          loading: "Loading…",
          noEvents: "No matching events could be found.",
          at: "{date} at {time}h",
          highlight: "Top-Event",
          cancelled: "Cancelled!"
        }
      },
      de: {
        message: {
          loading: "Lade…",
          noEvents: "Es wurden keine passenden Veranstaltungen gefunden.",
          at: "{date} um {time} Uhr",
          highlight: "Top-Veranstaltung",
          cancelled: "Abgesagt!"
        }
      }
    }
  });
}
